import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';

import { CommonModule } from '@angular/common';
import { AccountFacade } from '@mode/accounts/contract';
import { AccountsFeatureHeaderModule } from '@mode/accounts/feature-header';
import { ReportFacade } from '@mode/reports/domain';
import { BreadcrumbTypes } from '@mode/shared/contract-common';

@Component({
  standalone: true,
  imports: [AccountsFeatureHeaderModule, CommonModule],
  selector: 'mode-empty-report-header',
  templateUrl: './empty-report-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyReportHeaderComponent {
  orgContext$ = this._accountFacade.currentOrg$;
  emptyReportBreadCrumbs$: Observable<BreadcrumbTypes.Breadcrumb[]> = this._reportFacade.emptyReportBreadCrumbs$;

  constructor(
    private _accountFacade: AccountFacade,
    private _reportFacade: ReportFacade
  ) {}
}
